import { GetExcelRequest, GetRequest, PutRequest } from "../service"

const ControllerName = "ProviderProfile" // This controller for provider registration request

export const GetProviderProfile = () =>
    GetRequest(ControllerName)

export const GetProviderProfileInfo = () =>
    GetRequest(`${ControllerName}/getInfo`)

export const UpdateProviderProfile = (dataObject) =>
    PutRequest(`${ControllerName}`, dataObject)

export const GetProviderProfileExternalData = () =>
    GetExcelRequest(`${ControllerName}/download-services/excel`)

export const UploadProviderPricing = (dataObject) =>
    PutRequest(`${ControllerName}/upload-provider-pricing`, dataObject?.formData)